module.exports = __webpack_public_path__ + "img/ic_button.32f37429.png";